module.exports = __webpack_public_path__ + "img/mall.d885eb63.png";